<template>
    <div class="cb-section">
        <span class="cb-section__title cb-section__title--small">{{t('pm.set_role.title')}}</span>
        <span>{{t('pm.set_role.title_optional')}}</span>
        <div class="cb-section__body">
        <div class="cb-options" v-for="(role, index) in paymentRoles"  :id="role.value + '-radio-button'" :key='index' @click="setPaymentMethodRole(role)">
            <div class="cb-options__group">
                <div class="cb-options--align-top">
                    <div class="cb-options__radio cb-options__left pm-role-chkbox-icon" :style="role.value == payment_method_role && backgroundColor">
                        <i class="icon-check cb-options__icon" aria-hidden="true"></i>
                    </div>
                    <span class="cb-options__head cb-options__right pm-role-tile">
                        {{role.title}}
                    </span>
                </div>
                <div class="cb-mar--t-ti">
                    <div>
                    <p class="cb-options__desc pm-role-desc" :class="{'cb-pad--b-sm':getWarnNoteCondition(role)}">{{role.info}}</p>
                    
                        <cb-slide-n-fade>
                        <div class="cb-options__notes cb-transition__slide--short" v-if="getWarnNoteCondition(role)" >
                            <cb-notes :type="'suggestion'" :message="role.warn" :key="'notes'" :customClass="'cb-mar--t-no'"></cb-notes>
                        </div>
                        </cb-slide-n-fade>
                        
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Notes from "@/components/collections/elements/Notes";

const PRIMARY = 'primary';
const BACKUP = 'backup';

export default {
    props: ['payment_method_role'],
    components: {
        "cb-notes" : Notes
    },
    methods: {
        setPaymentMethodRole(role) {
            this.$emit('set-pm-role', role.value);
        },
        getWarnNoteCondition(role){
            switch(role.value){
                case PRIMARY:
                return this.showPrimaryWarnNote;
                case BACKUP:
                return this.showBackupWarnNote;
                default:
                return false;
            }
        },
    },
    computed: {
        ...mapGetters([
            "primary_pm",
            "backup_pm"
        ]),
        paymentRoles() {
            return [
                {
                title: this.t('payment_method_tag.primary'),
                info: this.t('pm.primary.info.txt'),
                warn: this.t('pm.primary.warning.txt'),
                value: PRIMARY
                },
                {
                title: this.t('payment_method_tag.backup'),
                info: this.t('pm.backup.info.txt'),
                warn: this.t('pm.backup.warning.txt'),
                value: BACKUP
                }
            ]
        },
        showPrimaryWarnNote() {
            return this.payment_method_role && this.payment_method_role == PRIMARY && this.primary_pm;
        },
        showBackupWarnNote() {
            return this.payment_method_role && this.payment_method_role == BACKUP && this.backup_pm;
        },
    }
}
</script>

<style scoped>
    .pm-role-tile{
        font-size: 14px;
        margin: 0 0 2px 7px;
    }
    .pm-role-desc{
        margin-top: 5px;
    }
    .pm-role-chkbox-icon{
        height: 18px;
        width: 18px;
    }
</style>